import * as React from "react"
import parse from "html-react-parser"

const HeaderScriptsComponent = ({data}) => (
    <>
        {data.entry.seomatic.metaTitleContainer && parse(data.entry.seomatic.metaTitleContainer)}
        {data.entry.seomatic.metaTagContainer && parse(data.entry.seomatic.metaTagContainer)}
        {data.entry.seomatic.metaLinkContainer && parse(data.entry.seomatic.metaLinkContainer)}
        {data.entry.seomatic.metaJsonLdContainer && parse(data.entry.seomatic.metaJsonLdContainer)}
        <link rel="icon" href="https://assets.cordiance.com/craft/modios-favicon.png" type="image/x-icon" />
        <script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>
    </>
)

export default HeaderScriptsComponent